import * as ROUTES from '../common/routes';
import * as C from '../common/constants';
import React, { useState } from 'react';
import { ReactComponent as IconSearch } from '../assets/svg/icon_search.svg';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { useSelector, useDispatch } from 'react-redux';
import { clearData } from '../common/app/actions';
import queryString from 'query-string';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useTranslations } from '../common/hooks/useTranslations';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      searchWrapperStyle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        maxHeight: '38px',
        width: '100%',
        height: '100%',
        border: `1px solid ${COLORS.appButtonsGray}`,
        backgroundColor: COLORS.white,
        borderRadius: '8px',
        boxSizing: 'border-box',
        marginBottom: '20px',
        // boxShadow: '11px 10px 26px -9px rgba(0, 0, 0, 0.64)',
      },
      searchInputStyle: {
        width: '100%',
        height: '30px',
        lineHeight: '21px',
        margin: '2px 0 0 10px',
        border: 'none',
        fontFamily: FONTS.alegreya,
        fontSize: '18px',
      },
      iconWrapperStyle: {
        width: '36px',
        height: '36px',
        padding: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: '0.7',
            transition: '0.5s ease',
          },
        },
      },
      iconStyle: {
        width: '20px',
        height: '20px',
        fill: COLORS.secondary,
      },
    })
);

const SearchInput = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();

  const searchLabel = useTranslations('search_placeholder');

  const { input } = queryString.parse(search);
  const [searchInput, setSearchInput] = useState(input);

  const onSearch = (event?: React.SyntheticEvent) => {
    event?.stopPropagation();
    event?.preventDefault();

    dispatch(clearData(C.SEARCH_DATA));

    navigate({
      pathname: ROUTES.SEARCH,
      search: `?input=${searchInput}`,
      // state: { detail: response.data }
    });
  };

  const onSearchEnter = (event) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  const onChange = (event) => {
    setSearchInput(event?.target?.value);
  };

  return (
    <div className={classes.searchWrapperStyle}>
      <input
        type="search"
        placeholder={searchLabel}
        className={classes.searchInputStyle}
        onChange={onChange}
        value={searchInput}
        onKeyDown={onSearchEnter}
      />
      <div className={classes.iconWrapperStyle} onClick={onSearch}>
        <IconSearch className={classes.iconStyle} />
      </div>
    </div>
  );
};

export default SearchInput;
